import { Outlet, createRootRoute } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: () => (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-aibo-primary/15 bg-white/70 backdrop-blur">
        <div className="mx-auto max-w-3xl px-6 py-4 flex items-center justify-between">
          <h1 className="text-lg font-semibold tracking-tight">
            <span className="text-aibo-primary">aibo</span>
            <span className="ml-2 text-aibo-ink/60 text-sm font-normal">恋愛タイプ診断 β</span>
          </h1>
          <span className="text-xs text-aibo-ink/50">学術的根拠ある AI カウンセリング</span>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-aibo-primary/10 py-4 text-center text-xs text-aibo-ink/40">
        © aibo · powered by Anthropic Claude
      </footer>
    </div>
  ),
});
